module.exports = __webpack_public_path__ + "img/file-empty.652cfb6e.png";